'use strict';

var React = require('react');
    
var Icon = React.createClass({displayName: "Icon",
    render: function () {
        return (
            React.createElement("div", {"data-filetype": this.props.filetype, className: "filepicker-file-icon"})
        );
    }
});

module.exports = Icon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dropzone-component/lib/icon.js
// module id = 3132
// module chunks = 1